module.exports = __webpack_public_path__ + "9f2011e77f427ec3450b960ce4d721b8.svg";